import { Select } from 'antd'
import React, { useEffect } from 'react'
import Loader from '../pages/pages/loader'
import { toast } from 'react-toastify'
import { useGetCustomerChannelsQuery } from '../redux/apis/customersManagement/channels/cMChannelsApiSlice'

const CustomerChannelsDropdown = ({
  onChange,
  onBlur,
  value,
  className = '',
  customer
}) => {
  const { data, isLoading, error } = useGetCustomerChannelsQuery({
    page: '*',
    customer: customer
  })
  useEffect(() => {
    if (!error && !isLoading) {
      return
    }
    toast.error(error)
  }, [error, isLoading])

  return (
    <div className=' mb-3'>
      <Loader isLoading={isLoading} />
      <label className="form-label">Customer Related Channel</label>
      <br />
      <Select
        name='app_name'
        className={className}
        showSearch
        style={{
          width: '100%'
        }}
        optionFilterProp='label'
        filterSort={(optionA, optionB) =>
          (optionA?.label ?? '')
            .toLowerCase()
            .localeCompare((optionB?.label ?? '').toLowerCase())
        }
        defaultValue={value}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        loading={isLoading}
        options={data?.data?.results?.map(x => {
          return { label: x.channel_name, value: x.id }
        })}
      />
    </div>
  )
}

export default CustomerChannelsDropdown
